import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
`;

export const NodeStyle = styled.div`
  cursor: pointer;

  * {
    cursor: pointer;
  }

  &.own-data {
    .own-data-header {
      display: flex;

      .left {
        width: 6px;
        background: var(--color-primary-70);
      }

      .right {
        flex: 1;
        padding: 6px;
        text-aling: left;
        display: flex;
        flex-direction: column;

        label {
          text-align: left;
          margin-bottom: 0px;
        }

        .info {
          display: flex;
          gap: 4px;
          margin-bottom: 4px;
          max-width: 160px;

          label {
            font-size: 7px;

            &.legal-form {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }  
  }
  

  &.default {
    .default-header {
      display: flex;
      flex-direction: column;
      padding: 6px;

      .info {
        display: flex;
        text-align: left;
        margin-bottom: 4px;

        .type {
          flex: 1;
          color: #9C9C9C;
          display: flex;
          gap: 2px;
        }

        label {
          margin-bottom: 0px;
          font-size: 8px;
        }
      }
    }
  }

  .id {
    color: var(--color-primary-70);
  }

  .sources {
    padding: 3px 12px;
    display: flex;
    border-top: 1px solid black;
    display: flex;
    gap: 3px;

    label {
      color: #595959;
      margin-bottom: 0px;
      font-size: 8px;
    }

    .circle {
      width: 10px;
      height: 10px;
      border-radius: 100%;
      margin-top: 1px;
      border: 2px solid white;

      &.supply-chain-actor {
        background: #52C41A;
      }

      &.other-info-source {
        background: #FF7875;
      }
    }

    svg {
      fill: #FFC700;
      font-size: 10px;
      margin-top: 1px;
    }
  }

  .subject-label {
    text-align: left;
    font-size: 10px;
    margin-bottom: 0px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 128px;
  }

  &.is-active {
    .sources {
      background: var(--color-primary-70);
      
      label {
        color: white;
      }
    }

    .subject-label {
      color: var(--color-primary-70);
      text-decoration: underline;
    }
  }
`;

export default styled.div`
  flex: 1;
  height: 500px;
  position: relative;

  .react-flow__node-default {
    padding: 0px;
  }
  
  .react-flow__handle.connectable {
    opacity: 0;
  }

  .react-flow__node-input.selected, .react-flow__node-input.selected:hover {
    box-shadow: none;
  }

  .header {
    position: absolute;
    top: 10px;
    z-index: 10;
    display: flex;

    .arrow {
      margin-top: -3px;
    }

    label {
      font-size: 17px;
      font-weight: 600;
      margin-bottom: 0px;
      // color: 
    }

    &.header-left {
      left: 20px;
    }

    &.header-right {
      right: 20px;
    }
  }
`;
